export { default } from "./DesignedFlatBox";
export * from "./DesignedFlatBox";
